import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { withTranslation } from "react-i18next";
import { generate } from "../routing/routes";
import cx from "classnames"
import * as customerTypes from "../constants/customer_types";
import { Link } from "react-router-dom";
import { ChevronDownIcon } from '@heroicons/react/20/solid'
// import PhoneNumberCaptor from './PhoneNumberCaptor';

const MyAccountButton = ({ user, t, standAlone, useLink=true, itemsLeft=true }) => {
    // const {data} = useSelector(state => state.account.userSession)
    // console.log(data, user)
    const [checkPhoneNumber, setCheckPhoneNumber]= useState(true);
    useEffect(()=>{
        if (!user.billingInformation.phoneNumber) {
           setCheckPhoneNumber(false);

        }
    }, [user])
    return <>
            {/* <PhoneNumberCaptor userHasPhoneNumber={checkPhoneNumber}/> */}
            <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button
                    className="account-btn  inline-flex items-center rounded-full border border-transparent bg-orange-600 p-2 py-1 text-sm font-medium text-white">
                    <p className='text-sm inline-flex'>
                        {t('account_button.your-account')}
                    <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                    </p>
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className={`menu-dropdown absolute ${itemsLeft?"right-0" :"lg:right-0"}  z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}>
                    {useLink?
                    
                    <div className="py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <Link
                                    to={generate("account_dashboard")}
                                    className={cx('block px-4 py-2 text-sm', {
                                        'bg-gray-100 text-gray-900' : active,
                                        'text-gray-700' : !active
                                    })}
                                    reloadDocument={standAlone}
                                >
                                    {t('account_button.dashboard')}
                                </Link>
                            )}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <Link
                                    to={generate("account_informations")}
                                    className={cx('block px-4 py-2 text-sm', {
                                        'bg-gray-100 text-gray-900' : active,
                                        'text-gray-700' : !active
                                    })}
                                    reloadDocument={standAlone}
                                >
                                    {t('account_button.my_account')}
                                </Link>
                            )}
                        </Menu.Item>
                        {user && customerTypes.BUSINESS === user.type && (
                        <>
                            <Menu.Item>
                                {({ active }) => (
                                    <Link
                                        to={generate("account_reservations")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                        reloadDocument={standAlone}
                                    >
                                        {t('account_button.reservations')}
                                    </Link>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <Link
                                        to={generate("account_quotations")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                        reloadDocument={standAlone}
                                    >
                                        {t('account_button.quotations')}
                                    </Link>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <Link
                                        to={generate("account_invoices")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                        reloadDocument={standAlone}
                                    >
                                        {t('account_button.invoices')}
                                    </Link>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <Link
                                        to={generate("account_documents")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                        reloadDocument={standAlone}
                                    >
                                        {t('account_button.documents')}
                                    </Link>
                                )}
                            </Menu.Item>
                        </>)}
                    </div>
                    :
                    <div className="py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <a
                                    href={generate("account_dashboard")}
                                    className={cx('block px-4 py-2 text-sm', {
                                        'bg-gray-100 text-gray-900' : active,
                                        'text-gray-700' : !active
                                    })}
                                
                                >
                                    {t('account_button.dashboard')}
                                </a>
                            )}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <a
                                    href={generate("account_informations")}
                                    className={cx('block px-4 py-2 text-sm', {
                                        'bg-gray-100 text-gray-900' : active,
                                        'text-gray-700' : !active
                                    })}
                                
                                >
                                    {t('account_button.my_account')}
                                </a>
                            )}
                        </Menu.Item>
                        {user && customerTypes.BUSINESS === user.type && (
                        <>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        href={generate("account_reservations")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                    
                                    >
                                        {t('account_button.reservations')}
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        href={generate("account_quotations")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                    
                                    >
                                        {t('account_button.quotations')}
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        href={generate("account_invoices")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                    
                                    >
                                        {t('account_button.invoices')}
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        href={generate("account_documents")}
                                        className={cx('block px-4 py-2 text-sm', {
                                            'bg-gray-100 text-gray-900' : active,
                                            'text-gray-700' : !active
                                        })}
                                    
                                    >
                                        {t('account_button.documents')}
                                    </a>
                                )}
                            </Menu.Item>
                        </>)}
                    </div>
                    }
                    <div className="py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <a
                                    href="/security/sign-out"
                                    className={cx('block px-4 py-2 text-sm', {
                                        'bg-gray-100 text-gray-900' : active,
                                        'text-gray-700' : !active
                                    })}
                                >
                                    {t('account_button.sign_out')}
                                </a>
                            )}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </Transition>
            </Menu>
        </>
}

export default withTranslation()(MyAccountButton);
